import { useMutation } from '@tanstack/react-query';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { IUserParams } from 'apis/GraphQL/Variables/user';
import RoleJobTitleApis from 'apis/RoleJobTitleApis';
import { ButtonFilter } from 'components';
import { useTitle } from 'contexts/TitleProvider';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { toastError, toastSuccess } from 'utils/constants/functions';
import FilterUpdateRole from './FilterUpdateRole';
import ModalPermission from './ModalPermission';
import TableUpdateRole from './TableUpdateRole';

type IFilter = Omit<IUserParams, 'page' | 'pageSize'>;

const initialState: any = {
  items: [],
};
export const rolesBase = [
  { id: 1, name: 'admin', title: 'Admin' },
  { id: 2, name: 'ho', title: 'Hội sở' },
  { id: 3, name: 'cn', title: 'Chi nhánh' },
  { id: 3, name: 'sale', title: 'Bán hàng' },
  { id: 3, name: 'nvtq', title: 'Nhân viên thủ quỹ' },
  { id: 3, name: 'nvtk', title: 'Nhân viên thủ kho' },
];
function UpdateRole() {
  const navigate = useNavigate(),
    { setTitle, setBreadcrumb } = useTitle();

  const [isOpenFilter, setIsOpenFilter] = useState(false),
    [editIndex, setEditIndex] = useState<number>(),
    [isOpenModal, setIsOpenModal] = useState(false);

  const [jobTitle, setjobTitle] = useState<any>([]),
    [jobTitleFilter, setjobTitleFilter] = useState<any>([]),
    [pageInfo, setPageInfo] = useState<any>([]),
    [filter, setFilter] = useState<IFilter>(),
    [dataEdit, setDataEdit] = useState<any>(initialState);

  const queryParam = useQueryParam(),
    page = parseInt(queryParam.get('page') + '') || 1,
    page_size = parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { isPending: getAllJobTitleLoading, mutate: getAllJobTitle } =
      useMutation({
        mutationFn: (param: any) => RoleJobTitleApis.getAllJobTitle(param),
        onSuccess: (res) => {
          const items = res.data.getJobTitle.items;
          setjobTitle(items);
          setPageInfo(res.data.getJobTitle.pageInfo);
        },
        onError: (error) => {
          console.log(error);
        },
      }),
    { isPending: getAllJobTitleFilterLoading, mutate: getAllJobTitleFilter } =
      useMutation({
        mutationFn: () => RoleJobTitleApis.getJobTitleComboBox(),
        onSuccess: (res) => {
          const items = res.data.getJobTitle.items;

          setjobTitleFilter(items);
        },
        onError: (error) => {
          console.log(error);
        },
      }),
    { isPending: updateRoleForJobTitleLoading, mutate: updateRoleForJobTitle } =
      useMutation({
        mutationFn: (param: any) => RoleJobTitleApis.updateJobTitle(param),
        onSuccess: (res) => {
          toastSuccess('Cập nhật thành công');
          setEditIndex(undefined);
          getAllJobTitle({ page: page, page_size: page_size, input: filter });
        },
        onError: (error) => {
          console.log(error);
        },
      });

  useEffect(() => {
    getAllJobTitle({ page: page, page_size: page_size, input: filter });
  }, [page, page_size, filter]);
  useEffect(() => {
    setTitle('Cập nhật Role - Job Title');
    setBreadcrumb([
      { title: 'Hệ thống' },
      { title: 'Cập nhật Role - Job Title' },
    ]);
    // getAllRole();
    getAllJobTitleFilter();
  }, []);
  useEffect(() => {
    if (editIndex === undefined) return;

    const data = jobTitle[editIndex];
    setDataEdit(data);
  }, [editIndex]);

  const handleFilter = (values: any) => {
    navigate(`?page=1&page_size=${page_size}`);
    const trimmedValues = {
      ...values,
      id: values.id?.trim(),
      jobName: values.jobName?.trim(),
      role: values.role?.trim(),
    };
    setFilter(trimmedValues);
  };
  function UpdateRole(values: any) {
    if (!values.roleId) {
      toastError('Vui lòng chọn quyền');
      return;
    }
    updateRoleForJobTitle(values);
    setIsOpenModal(false);
  }

  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <ButtonFilter isOpen={isOpenFilter} setIsOpen={setIsOpenFilter} />
        </Col>
      </Row>
      <FilterUpdateRole
        open={isOpenFilter}
        dataOption={jobTitleFilter}
        onFinish={handleFilter}
        setValueFilter={setFilter}
        setIsOpenFilter={setIsOpenFilter}
      />
      <TableUpdateRole
        loading={
          getAllJobTitleLoading ||
          getAllJobTitleFilterLoading ||
          // loadingAllrole ||
          updateRoleForJobTitleLoading
        }
        data={jobTitle}
        setEditIndex={setEditIndex}
        setOpenModal={setIsOpenModal}
        pageInfo={pageInfo}
      />
      <ModalPermission
        open={isOpenModal}
        data={dataEdit}
        title={'Chỉnh sửa quyền cho Job Title'}
        setOpen={setIsOpenModal}
        onFinish={UpdateRole}
      />
    </>
  );
}

export default UpdateRole;
